import { RichTooltipAggrid } from '@mint-lib/tw-components';

type InfoTooltipProps = {
  value: string;
};

export const InfoTooltip = ({ value }: InfoTooltipProps) => {
  return <RichTooltipAggrid type="info">{value}</RichTooltipAggrid>;
};
